import React from "react";
import Aboutme from "./Details/Aboutme";
import Experience from "./Details/Experience";
import Skills from "./Details/Skills";
import Volunteers from "./Details/Volunteers";
import Footer from "./Footer";
import Home from "./Home";

function Homepage() {
  return (
    <div>
      <Home />
      <Aboutme />
      <Experience />
      <Volunteers />
      <Skills />
      <Footer />
    </div>
  );
}

export default Homepage;
